import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { Dispatch, Store } from "redux"
import { StateObject } from "../components/redux/types"

// Sometimes we want to access redux from 'outside', i.e. in logging fuctions,
// for that cases, getStore.getState() below becomes handy.
let globalStore: Maybe<Store<StateObject>>
export const getStore = (): Maybe<Store<StateObject>> => globalStore
export const setStore = (store: Store<StateObject>) => {
    globalStore = store
}

export const getDispatch = (): Maybe<Dispatch<any>> => {
    if (!globalStore) {
        return null
    }

    return globalStore.dispatch
}
